import { LayoutConfig } from '@spartacus/storefront'

export const ebProductGridLayoutConfig: LayoutConfig = {
  layoutSlots: {
    ProductGridPageTemplate: {
      slots: ['BreadcrumbSlot', 'ProductLeftRefinements', 'ProductGridSlot', 'Section4', 'Matomo']
    },
    ProductDetailsPageTemplate: {
      lg: {
        pageFold: 'UpSelling'
      },
      pageFold: 'Summary',
      slots: [
        'BreadcrumbSlot',
        'Summary',
        'UpSelling',
        'CrossSelling',
        'Tabs',
        'PlaceholderContentSlot',
        'Matomo'
      ]
    }
  }
}
